// PostHog Analytics Configuration — fully lazy-loaded
// posthog-js is NOT imported at module level to keep it out of the main bundle.

export const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'phc_4ugtNrTTrOedr2DuFpiAEfy51R67fCApoiT9XxFPLyb';
export const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

export const posthogOptions = {
  api_host: POSTHOG_HOST,
  defaults: '2026-01-30',
  // PostHog fetches each optional add-on as its own third-party script at init.
  // Nothing on this site uses these three, and together they cost ~45 KB of JS
  // on every page load. Session replay and autocapture are NOT affected.
  disable_surveys: true,                       // surveys.js            ~34 KB
  capture_dead_clicks: false,                  // dead-clicks-autocapture.js ~7 KB
  capture_performance: { web_vitals: false },  // web-vitals.js          ~4 KB
} as const;

// Lazy singleton — resolves to the posthog instance once loaded
let posthogPromise: Promise<typeof import('posthog-js')['default']> | null = null;

function getPosthog() {
  if (!posthogPromise) {
    posthogPromise = import('posthog-js').then(m => m.default);
  }
  return posthogPromise;
}

// Fire-and-forget tracking — never blocks the UI
const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  getPosthog().then(ph => ph.capture(eventName, properties)).catch(() => {});
};

export const trackEmailOptIn = (source: string) => {
  trackEvent('email_opt_in', { source });
};

export const trackSampleChapterRequest = () => {
  trackEvent('sample_chapter_request');
};

export const trackContactFormSubmission = (inquiryType?: string) => {
  trackEvent('contact_form_submission', { inquiry_type: inquiryType });
};

export const trackButtonClick = (buttonName: string, page?: string) => {
  trackEvent('button_click', { button_name: buttonName, page });
};

export const trackExternalLinkClick = (url: string, linkText?: string) => {
  trackEvent('external_link_click', { url, link_text: linkText });
};

export const trackPageView = (pageName: string) => {
  trackEvent('page_view', { page_name: pageName });
};
